import { ExclamationMarkTriangleFill, Reload } from '@o2/icons';
import { Button, Stack, Typography } from '@o2/ui';
import { FC, MouseEventHandler, ReactNode } from 'react';
import CopyButton, { CopyButtonProps } from '../CopyButton';

export interface ErrorStatusProps {
  /**
   * Custom error text. (ReactNode)
   */
  text?: ReactNode;

  /**
   * Reload button click handler. If `undefined`, then the reload button is hidden.
   */
  onReloadClick?: MouseEventHandler;

  /**
   * Custom reload button text. (ReactNode)
   */
  reloadBtnText?: ReactNode;

  /**
   * Enables display in internal mode.
   */
  internal?: boolean;

  /**
   * Internal copy button click handler. Returns CopyStatus.
   */
  onInternalCopyBtnClick?: CopyButtonProps['onClick'];

  /**
   * Custom props for internal copy button.
   */
  CopyButtonProps?: Partial<CopyButtonProps>;
}

const ErrorStatus: FC<ErrorStatusProps> = ({
  text = 'Tuto sekci se nám bohužel nepodařilo načíst.',
  onReloadClick,
  reloadBtnText = 'Znovu načíst',
  internal = false,
  onInternalCopyBtnClick,
  CopyButtonProps,
  ...other
}) => {
  return (
    <Stack direction="column" alignItems="center" gap={3} {...other}>
      <ExclamationMarkTriangleFill sx={{ fontSize: '48px' }} color="warning" />
      <Typography textAlign="center">{text}</Typography>
      {(onReloadClick || (internal && onInternalCopyBtnClick)) && (
        <Stack direction="row" alignItems="center" gap={2}>
          {onReloadClick && (
            <Button onClick={onReloadClick} variant="text" startIcon={<Reload />}>
              {reloadBtnText}
            </Button>
          )}
          {internal && onInternalCopyBtnClick && <CopyButton onClick={onInternalCopyBtnClick} {...CopyButtonProps} />}
        </Stack>
      )}
    </Stack>
  );
};

export default ErrorStatus;
